import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import { FileUploadWithPreview } from 'file-upload-with-preview';
import language from '../../js/stores/language.js';
function framework7Component(props, _ref) {
  var $ = _ref.$,
    $f7 = _ref.$f7,
    $on = _ref.$on,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted,
    $f7route = _ref.$f7route,
    $f7router = _ref.$f7router;
  var locale = language.getters.Item.value;
  var CarList = [];
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var upload;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          upload = new FileUploadWithPreview('my-unique-id', {
            maxFileCount: 5,
            multiple: true,
            accept: 'image/jpeg,image/jpg',
            text: {
              browse: 'Browse',
              //chooseFile: 'Take your pick...',
              label: 'Upload your cars pictures'
              //selectedCount: DEFAULT_FILES_SELECTED_TEXT,
            }
          });
          $update();
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="car-lending">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">Back</span>
        </a>
      </div>
      <div class="title">Car Lending</div>
    </div>
  </div>
  <div class="page-content">
    <div class="block-title">Car Lending Page</div>
    <div class="block">
      <form id="car-form-lending" class="list no-hairlines-md">
        <input id="-id" name="Id" type="hidden" value="0" />
        <ul id="use-car-section" class="disabled">
          <li>
            <div class="item-content item-input">
              <div class="item-inner">
                <div class="item-title item-label">Huidige Kilometerstand</div>
                <div class="item-input-wrap">
                  <input id="car-Kilometers" name="CarKilometers" type="numer" placeholder="Huidige Kilometerstand" autocomplete="off" value=""/>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </form>
    </div>
    <div class="custom-file-container list block text-align-center" data-upload-id="my-unique-id"></div>
  </div>
</div>
`
    }
    ;
}
framework7Component.id = 'b15f9b560e';
export default framework7Component;